import React from 'react'
import Modal from './Modal'
import AuthForm from './AuthForm'

export interface AuthModalProps {
  isOpen: boolean
  onClose: () => void
  initialMode?: 'signIn' | 'signUp'
}

export default function AuthModal({
  isOpen,
  onClose,
  initialMode
}: AuthModalProps): React.JSX.Element {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={initialMode === 'signUp' ? 'Sign up' : 'Log in'}
    >
      <AuthForm initialMode={initialMode} />
    </Modal>
  )
}
